import { gql } from "@apollo/client";

export default gql`
  mutation updateTopicSharedOrIndividualNotesMutation(
    $topicId: Int
    $includesIndividualNotes: Boolean
    $includesSharedNotes: Boolean
    $meetingId: Int
  ) {
    createOrUpdateTopic(
      topicId: $topicId
      includesIndividualNotes: $includesIndividualNotes
      includesSharedNotes: $includesSharedNotes
      meetingId: $meetingId
    ) {
      topic {
        id
        includesIndividualNotes
        includesSharedNotes
      }
    }
  }
`;
